module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-content"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-57875868"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ci-components/components/content.vue
// module id = 256
// module chunks = 4